import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import arrowLink from "../../assets/images/arrowLink.png"
//imports from component folder
import {
  AuthHeader,
  CustomTitle,
  CustomModalWithoutButton,
  CustomParagraph,
  StatusCardNotification,
  CustomButton,
} from "../../components";
import {
  GoogleMapsProvider,
  useGoogleMaps,
} from "../../components/GoogleMapsProvider";
import { useSpin } from "../../components/SpinContext";

//import from within folder
import AuthenticateShareShipment from "./AuthenticateShareShipment";
import ShipmentMap from "./ShipmentMap";

//images from assets
import lightIcon from "../../assets/images/lightIcon.svg";
import humidityIcon from "../../assets/images/humidityIcon.svg";
import CommentIcon from "../../assets/images/comment.png";
import AtRisk from "../../assets/images/yellow Avatar.png";
import WhiteLogo from "../../assets/images/logo.svg";
import temp from "../../assets/images/temp.png";
import time from "../../assets/images/time.png";
import battery from "../../assets/images/battery.png";

import {
  HumidityIcon,
  PressureIcon,
  TiltIcon,
  LightIcon,
  ShockIcon,
  TempratureRangeIcon,
  BatteryIcon,
  VibilityWindowIcon,
} from "../../assets/icons/icons.js";

//antd imports components + icons
import { Col, Divider, Flex, Row, Tag, Timeline, message, Tooltip } from "antd";
import {
  ExclamationCircleFilled,
  LeftOutlined,
  MinusOutlined,
  WarningFilled,
  CheckOutlined,
  RightOutlined,
} from "@ant-design/icons";

//import for api's
import {
  CheckPasswordAgaintUUID,
  GetShipmentAlertsPublically,
  GetSingleShipment,
  GetSingleShipmentPublically,
  GetShipmentAlerts,
} from "../../api's/shipment";

//import from common
import { useToken, appHelper } from "../../common/helper";

//import from Modal folder
import {
  LightModal,
  TemperatureModal,
  BatteryModal,
  HumidityModal,
} from "../Modals";

//import { GetSingleShipment, GetSingleShipmentPublically, GetShipmentAlerts } from "../../api's/shipment";
// import CustomTitle from "../../components/CustomTitle";
// import CustomModalWithoutButton from "../../components/CustomModalWithoutButtons";
//import TemperatureModal from "../Modals/TempratureModal";
//import BatteryModal from "../Modals/BatteryModal";
// import CustomParagraph from "../../components/CustomParagraph";
import { GoogleMap } from "@react-google-maps/api";
import PressureChartModal from "../Modals/PressureChartModal.jsx";
import TiltModal from "../Modals/TiltModal.jsx";
import ExternalMapAlertsForm from "./partials/ExternalMapAlertsForm.jsx";
//import { message } from "antd";
//import { CustomImage } from "../../components";

//import { GetShipmentAlerts } from "../../api's/shipment";
// import StatusCardNotification from "../../components/StatusCardNotification";
//import HumidityModal from "../Modals/HumidityModal";
//import LightModal from "../Modals/LightModal";

function MapExternalView() {
  const navigate = useNavigate();
  const { showSpin, hideSpin } = useSpin();
  const { token, removeToken, decodedUserToken } = useToken();
  const [shipment, setShipment] = useState({});
  const [pointState, setPointState] = useState(null);
  const { capitalize, changeToTimeString } = appHelper();
  const [alertsData, setAlertsData] = useState(null);
  const [showAlertForm, setShowAlertForm] = useState(false);

  const [alertType, setAlertType] = useState(null);
  const [tempratureModalOpen, setTempratureModalOpen] = useState(false);
  const [tiltModalOpen, setTiltModalOpen] = useState(false);
    const [pressureModalOpen, setPressureModalOpen] = useState();
  
  const [batteryModalOpen, setBatteryModalOpen] = useState(false);
  const [passwordRequired, setPasswordRequired] = useState(false);
  const [lightModalOpen, setLightModalOpen] = useState(false);
  const [humidityModalOpen, setHumidityModalOpen] = useState(false);
  const [showAlerts, setShowAlerts] = useState(false);
  const [productDetails, setProductDetails] = useState(false);
  const [password, setPassword] = useState("");
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const { id, uuid } = useParams();
  const [clikedPointCoordinates, setClickedPointCoordinates] = useState({
    lat: 0,
    lng: 0,
  });
  const [toCoordinates, setToCoordinates] = useState(null);
  const [currentView, setCurrentView] = useState("summary");
  const location = useLocation();
   const isSharePage = location.pathname.includes("/share");
  const [alertIndex, setAlertIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  const [companyId, setCompanyId] = useState(null);
  const [startAlertsInterval, setStartAlertsInterval] = useState(true);
  let decodedToken = decodedUserToken();
  const toggleDrawer = () => {
    setIsVisible((prev) => !prev);
  };
  const truncateText = (text, maxLength = 23) => {
    if (!text) return "";
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
  };

  const [shouldRender, setShouldRender] = useState(false);
  useEffect(() => {
    if (showAlertForm) {
      setShouldRender(true);
    }
  }, [showAlertForm]);
  
  const handleClose = () => {
    setShowAlertForm(false);
    setTimeout(() => setShouldRender(false), 500); // Match animation duration
  };


  useEffect(() => {
    if (uuid) {
      CheckPasswordAgaintUUID(uuid)
        .then((res) => {
          const data = res?.data || null;
          if (data) {
            if (data?.data?.is_success) {
              if (data?.data?.data?.require_password) {
                setPasswordRequired(true);
              }
            } else {
              message.error(data?.data?.message);
            }
          }
        })
        .catch(() => {
          message.error("Error while generating the shareable link.");
        })
        .finally(() => {
          hideSpin();
        });
    }
  }, [uuid, navigate]);


  useEffect(() => {
    if (uuid && id && !token) {
      fetchSingleShipmentDataForPublic(uuid, true);
    }
  }, [uuid, id]);

  useEffect(() => {
    const fetchShipmentDataPublically = () => {
      if (id && !token) {
        getShipmentAlertsPublically(false);
        if (uuid) {
          fetchSingleShipmentDataForPublic(uuid, false);
        }
      }
    };
    if (startAlertsInterval) {
      const intervalId = setInterval(() => {
        fetchShipmentDataPublically();
      }, 30000);
      return () => clearInterval(intervalId);
    }
  }, [uuid, id, startAlertsInterval]);

  useEffect(() => {
    if (id && !token) {
      getShipmentAlertsPublically(true);
    }
  }, [id]);

  useEffect(() => {
    if (token) {
      fetchSingleShipmentData(true);
      getShipmentAlerts(true);
    }
  }, [token, id]);

  useEffect(() => {
    const fetchAuthorizeShipmentData = () => {
      if (token) {
        fetchSingleShipmentData(false);
        getShipmentAlerts(false);
      }
    };
    if (startAlertsInterval) {
      const intervalId = setInterval(() => {
        fetchAuthorizeShipmentData();
      }, 30000);
      return () => clearInterval(intervalId);
    }
  }, [uuid, id, startAlertsInterval]);

  const getShipmentAlertsPublically = (showSpiner) => {
    if (showSpiner) {
      showSpin();
    }
    GetShipmentAlertsPublically(id)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            let resp = data?.data?.data ? data?.data?.data : [];
            if (resp) {

              setAlertsData(resp);
            }
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  // useEffect(() => {
  //   if (id) {
  //     getShipmentAlerts();
  //   }
  // }, [id]);

  const getShipmentAlerts = (showSpiner) => {
    if (showSpiner) {
      showSpin();
    }

    GetShipmentAlerts(token, id) //shipment/alert
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            let resp = data?.data?.data ? data?.data?.data : [];
            if (resp) {
              setAlertsData(resp);
              //setAlertType(res.alert_type);
            }
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  const updateTrackingInfo = (item) => {
    let model = {
      temperature: item?.temperature || "",
      lat_updated: item?.lat_updated || "",
      humidity: item?.humidity || "",
      battery: item?.battery || "",
    };
    setPointState(model);
    setClickedPointCoordinates({
      lat: item?.latitude ? item?.latitude : 0,
      lng: item?.longitude ? item?.longitude : 0,
    });
  };

  // useEffect(() => {
  //   fetchSingleShipmentDataForPublic();
  // }, []);

  const fetchSingleShipmentDataForPublic = (data, showSpiner) => {
    if (showSpiner) {
      showSpin();
    }
    GetSingleShipmentPublically(data, id)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            let resp = data?.data?.data ? data?.data?.data : null;
            if (resp) {
              setCompanyId(resp.company);
              if (
                resp?.shipment_monitor &&
                resp?.shipment_monitor?.length > 0
              ) {
                updateTrackingInfo(
                  resp?.shipment_monitor[resp?.shipment_monitor?.length - 1]
                );
              }
              setShipment(resp);
            }
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };
  const truncateByLength = (text, maxLength = 23) => {
    if (!text) return "";
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
  };

  const fetchSingleShipmentData = (showSpiner) => {
    let t = localStorage.getItem("@token");
    if (showSpiner) {
      showSpin();
    }

    GetSingleShipment(t, id)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            let resp = data?.data?.data ? data?.data?.data : null;
            if (resp) {
              if (
                resp?.shipment_monitor &&
                resp?.shipment_monitor?.length > 0
              ) {
                updateTrackingInfo(
                  resp?.shipment_monitor[resp?.shipment_monitor?.length - 1]
                );
              }
              setShipment(resp);
            }
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  const goBackToShipment = () => {
    navigate("/shipment");
  };

  const handleLightModal = () => {
    if (shipment?.shipment_monitor && shipment?.shipment_monitor?.length > 0) {
      setLightModalOpen(true);
    }
  };

  const handleHumidityModal = () => {
    if (shipment?.shipment_monitor && shipment?.shipment_monitor?.length > 0) {
      setHumidityModalOpen(true);
    }
  };

  const handleCurrentView = (val) => {
    setCurrentView(val);
  };

  const handleTempratureModal = () => {
    if (shipment?.shipment_monitor && shipment?.shipment_monitor?.length > 0) {
      setTempratureModalOpen(true);
    }
  };

  const handleTiltModal = () => {
    if (shipment?.shipment_monitor && shipment?.shipment_monitor?.length > 0) {
      setTiltModalOpen(true);
    }
  };

  const handlePressureModal = () => {
    if (shipment?.shipment_monitor && shipment?.shipment_monitor?.length > 0) {
      setPressureModalOpen(true);
    }
  };

  const handleBatteryModal = () => {
    if (shipment?.shipment_monitor && shipment?.shipment_monitor?.length > 0) {
      setBatteryModalOpen(true);
    }
  };




  const getTagStyles = (min, max, current) => {
    if (current === null || current === undefined || current === '') {
      return {
        backgroundColor: "#F3F3F3", // light gray
        color: "#333333",           // dark gray text
      };
    }
  
    const numericCurrent = Number(current);
    const numericMin = typeof min === "number" ? min : undefined;
    const numericMax = typeof max === "number" ? max : undefined;
  
    // Case: Exact match with min or max
    if (
      (numericMin !== undefined && numericCurrent === numericMin) ||
      (numericMax !== undefined && numericCurrent === numericMax)
    ) {
      return {
        backgroundColor: "#EAF6ED", // green bg
        color: "#0E8345",           // green text
      };
    }
  
    // Case: Both min and max are defined
    if (numericMin !== undefined && numericMax !== undefined) {
      const range = numericMax - numericMin;
      const lowerBound = numericMin + range * 0.2;
      const upperBound = numericMax - range * 0.2;
  
      if (numericCurrent < numericMin || numericCurrent > numericMax) {
        return {
          backgroundColor: "#FFF0EE", // light red bg
          color: "#BB032A",           // red text
        };
      } else if (
        numericCurrent < lowerBound || numericCurrent > upperBound
      ) {
        return {
          backgroundColor: "#FDF2DC", // light orange bg
          color: "#9F6402",           // orange text
        };
      } else {
        return {
          backgroundColor: "#EAF6ED", // green bg
          color: "#0E8345",           // green text
        };
      }
    }
  
    // Case: Single value provided (min or max only)
    const reference = numericMin ?? numericMax;
  
    if (typeof reference === "number") {
      const diff = Math.abs(numericCurrent - reference);
      const threshold = reference * 0.2;
  
      if (numericCurrent === reference) {
        return {
          backgroundColor: "#EAF6ED",
          color: "#0E8345",
        };
      } else if (diff <= threshold) {
        return {
          backgroundColor: "#FDF2DC", // light orange
          color: "#9F6402",           // orange text
        };
      } else {
        return {
          backgroundColor: "#FFF0EE", // light red
          color: "#BB032A",           // red text
        };
      }
    }
  
    // Default fallback
    return {
      backgroundColor: "#EAF6ED",
      color: "#0E8345",
    };
  };
  
  const getBatteryTagStyles = (battery) => {
    if (battery === null || battery === undefined || battery === '') {
      return {
        backgroundColor: "#F3F3F3", // light gray for no value
        color: "#333333",           // dark gray text
      };
    }
  
    if (battery <= 10) {
      return {
        backgroundColor: "#FFF0EE", // light red
        color: "#BB032A",           // red text
      };
    }
  
    if (battery <= 20) {
      return {
        backgroundColor: "#FDF2DC", // light orange
        color: "#9F6402",           // orange text
      };
    }
  
    return {
      backgroundColor: "#EAF6ED", // light green
      color: "#0E8345",           // green text
    };
  };
  

  const getVibilityWindowStyles = (current, status, scheduled_delivery_date) => {
    if (!current || current === "00:00:00") {
      return {
        backgroundColor: "#f3f3f3", // light gray
        color: "#333333",           // dark gray
      };
    }
  
    const now = new Date();
    const scheduledDate = new Date(scheduled_delivery_date);
  
    const isDelayedAndDelivered = status?.toLowerCase() !== "delivered" && now > scheduledDate;
  
    if (isDelayedAndDelivered) {
      return {
        backgroundColor: "#FFF0EE", // light red
        color: "#BB032A",           // red
      };
    }
  
    return {
      backgroundColor: "#EAF6ED", // light green
      color: "#0E8345",           // green
    };
  };
  
  

  return (
    <>
      {passwordRequired ? (
        <AuthenticateShareShipment
          setShowAlerts={setShowAlerts}
          setProductDetails={setProductDetails}
          setPasswordRequired={setPasswordRequired}
          uuid={uuid}
        />
      ) : (
        <>
          <AuthHeader
            bgColor="#3D81FF"
            color="#fff"
            companyId={companyId}
            logo={WhiteLogo}
            isMapPage={true}
            isSharePage={isSharePage}
            currentView={currentView}
            setCurrentView={handleCurrentView}
          />

          {/* <div className="map-settings">
            {!isSharePage && (
              <ArrowLeftOutlined
                onClick={goBackToShipment}
                style={{ color: "#fff" }}
              />
            )}

            <Flex gap={16} style={{ marginLeft: "20px" }}>
              <Radio.Group
                value={currentView}
                onChange={(e) => setCurrentView(e.target.value)}
              >
                <Radio.Button value="summary">Summary</Radio.Button>
                <Radio.Button value="detail">Detailed</Radio.Button>
              </Radio.Group>
            </Flex>
          </div> */}

          <div className="map-container" style={{ top: "0px" }}>
            <GoogleMapsProvider>
              <ShipmentMap
                shipment={shipment}
                currentView={currentView}
                clickedPointCoordinates={clikedPointCoordinates}
                onPointClicked={updateTrackingInfo}
                height={"calc(100vh - 56px)"}
                isLargeScreen={true}
              />
            </GoogleMapsProvider>

            <div className="custom-map-btn">
              <button className="custom-map-card-btn" onClick={toggleDrawer}>
                Delivery Detail
              </button>
              <div
                className={`custom-card-drawer custom-map-card ${showAlertForm && 'for-alert-form'} ${
                  isVisible ? "visible" : ""
                }`}
              >
                       
      <div className={`fade-wrapper ${showAlertForm ? 'fade-in' : 'fade-out'}`}>

             <ExternalMapAlertsForm setShowAlertForm={handleClose} externalToken={uuid} />
                    </div>
                    {!showAlertForm &&
                    <div className={`fade-wrapper ${showAlertForm ? 'fade-out' : 'fade-in' }`}>
                <Flex vertical={true} gap={10}>
                  <Flex
                    gap={0}
                    vertical={true}
                    className="custom-card-drawer-header"
                  >
                    <CustomTitle
                      text="Reference ID"
                      fontSize={12}
                      fontWeight={600}
                      color={'#5e5e5e'}
                      lineHeight={"16px"}
                      marginBottom={0}
                    />
                    <Flex  gap={8} align="center">

                    <CustomTitle
                      text={truncateByLength(shipment.reference_number, 23)}
                      fontSize={18}
                      fontWeight={700}
                      lineHeight="24px"
                      color="#000"
                      marginBottom="0"
                      marginTop={0}
                      />
                      {isSharePage ?
                                             <CustomButton
onClick={()=>setShowAlertForm(true)}
text={"Alerts"}
width="75px"
height="28px"
minWidth="78px"
color="#000"
bgColor="#fff"
gap="10px"
fontSize="12px"
fontWeight={600}
lineHeight={"16px"}
boxShadow="1px 1px 2px rgba(0, 0, 0, 0.1)"
border="1px solid #D9D9D9"
borderRadius="40px"
iconPosition="left"
icon={<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 10.875C6.55 10.875 7 10.425 7 9.875H5C5 10.425 5.445 10.875 6 10.875ZM9 7.875V5.375C9 3.84 8.18 2.555 6.75 2.215V1.875C6.75 1.46 6.415 1.125 6 1.125C5.585 1.125 5.25 1.46 5.25 1.875V2.215C3.815 2.555 3 3.835 3 5.375V7.875L2 8.875V9.375H10V8.875L9 7.875Z" fill="black"/>
</svg>
}/>
: null}

                      </Flex>
                  </Flex>
                {((isSharePage && showAlerts) || !isSharePage) ? (
                    <>
                      {alertsData?.length > 0 &&
                        alertsData.map((alert, index) => {
                          
                            return (
                              // <div style={{ paddingTop: "10px" }}>
                            <React.Fragment key={alert.id}>
                              {alertIndex === index && (
                                <>
                                {/* <div style={{marginBottom:(alertsData.length === 1 ? "10px" : "0px")}}> */}
                                  <StatusCardNotification
                                    cardStyle={"style-1"}
                                    icon={<WarningFilled />}
                                    title={alert?.title || ""}
                                    description={alert?.detail || ""}
                                    createdAt={alert?.created_at || ""}
                                    bgColor={
                                      alert?.is_critical === false
                                        ? "#F6BC2F"
                                        : "#DE1135"
                                    }
                                    color={
                                      alert?.is_critical === false
                                        ? "#000"
                                        : "#fff"
                                    }
                                    showButtons={false}
                                    actionButtonText={"Mark as Resolved"}
                                    actionButtonWidth="112px"
                                    actionButtonBorderRadius="8px"
                                    actionButtonBgColor={
                                      alert?.is_critical === false
                                        ? "#FBE5B6"
                                        : "#BB032A"
                                    }
                                  />
                                 

                                  {alertsData.length > 1 && (
                                    <Flex
                                      style={{ margin: "-5px 0px 0px 0px" }}
                                      justify="space-between"
                                      align="center"
                                      className="custom-card-drawer-header"
                                    >
                                      <p
                                        style={{
                                          color: "#000",
                                          marginBottom: "0px",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {index + 1} of {alertsData.length}{" "}
                                        issues
                                      </p>
                                      <Flex
                                        gap={8}
                                        align="center"
                                        className="custom-card-drawer-header-actions"
                                      >
                                        <button
                                          style={{
                                            border: 0,
                                            borderRadius: "50px",
                                          }}
                                          title="Previous Alert"
                                          onClick={() => {
                                            if (alertIndex > 0) {
                                              setAlertIndex(alertIndex - 1); // Decrease the alertIndex by 1
                                            }
                                          }}
                                        >
                                          <LeftOutlined
                                            style={{
                                              fontSize: "12px",
                                              color:
                                                index === 0
                                                  ? "#AFAFAF"
                                                  : "#000",
                                            }}
                                          />
                                        </button>

                                        <button
                                          style={{
                                            border: 0,
                                            borderRadius: "50px",
                                          }}
                                          title="Next Alert"
                                          onClick={() => {
                                            if (
                                              alertIndex <
                                              alertsData.length - 1
                                            ) {
                                              setAlertIndex(alertIndex + 1); // Decrease the alertIndex by 1
                                            }
                                          }}
                                        >
                                          <RightOutlined
                                            style={{
                                              fontSize: "12px",
                                              color:
                                                index === alertsData.length - 1
                                                  ? "#AFAFAF"
                                                  : "#000",
                                            }}
                                          />
                                        </button>
                                      </Flex>
                                    </Flex>
                                  )}
                                   {/* </div> */}
                                </>
                              )}
                            </React.Fragment>
                            // </div>
                            );
                            {/* {alertType == 2 && (
                      <StatusCardNotification
                        cardStyle={"style-1"}
                        icon={<WarningFilled style={{ color: "#fff" }} />}
                        title={alertsData?.title || ""}
                        description={alertsData?.detail || ""}
                        bgColor="#DE1135"
                        color={"#fff"}
                        showButtons={false}
                        actionButtonWidth="112px"
                        actionButtonBorderRadius="8px"
                        actionButtonBgColor="#BB032A"
                        />
                    )}
                    {alertType == 1 && (
                      <StatusCardNotification
                        cardStyle={"style-1"}
                        icon={<WarningFilled />}
                        title={alertsData?.title || ""}
                        description={alertsData?.detail || ""}
                        bgColor="#F6BC2F"
                        color={"#000"}
                        showButtons={false}
                        actionButtonWidth="112px"
                        actionButtonBorderRadius="8px"
                        actionButtonBgColor="#FBE5B6"
                      />
                      )} */}
                          // </div>;
                        })}
                    </>
                   ) : null} 

                  <Flex vertical={true} gap={10}>
                    <Row gutter={[16, 16]} justify="space-between">
                      <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <CustomParagraph
                          text={"Delivery status"}
                          fontSize={12}
                          fontWeight={600}
                          lineHeight="16px"
                          color="#000"
                          marginBottom="4px"
                        />

                        <Tag
                          color={
                            shipment?.delivery_status
                              ?.toLowerCase()
                              .includes("on time") ||
                            shipment?.delivery_status?.toLowerCase() ===
                              "delivered"
                              ? "#EAF6ED"
                              : shipment?.delivery_status?.includes("Late")
                              ? "#FFF0EE"
                              : "rgb(243, 243, 243)"
                          }
                          style={{
                            borderRadius: "8px",
                            color:
                              shipment?.delivery_status?.toLowerCase() ===
                                "on time" ||
                              shipment?.delivery_status?.toLowerCase() ===
                                "delivered"
                                ? "#0E8345"
                                : shipment?.delivery_status?.includes("Late")
                                ? "#DE1135"
                                : "rgb(75, 75, 75)",
                            fontSize: "10px",
                          }}
                        >
                          {shipment?.delivery_status}
                        </Tag>
                        {/* <CustomParagraph text={shipment?.status} fontSize={14} fontWeight={400} lineHeight="20px" color="#4B4B4B" marginBottom="0" /> */}
                        {/* <CustomParagraph text={shipment?.shipment_details?.destination?.address} fontSize={14} fontWeight={400} lineHeight="20px" color="#4B4B4B" marginBottom="0" /> */}
                      </Col>

                      <Col
                        title={
                          shipment?.type === 3
                            ? shipment?.actual_delivery_date
                            : shipment?.estimated_delivery_date
                        }
                        xxl={12}
                        xl={12}
                        lg={12}
                        md={12}
                        sm={24}
                        xs={24}
                      >
                        <CustomParagraph
                          text={
                            shipment?.type === 3
                              ? "Delivered on"
                              : "ZoomLogi ETA"
                          }
                          fontSize={12}
                          fontWeight={600}
                          lineHeight="20px"
                          color="#000"
                          marginBottom="4px"
                        />

                        <CustomParagraph
                          text={truncateText(
                            shipment?.type === 3
                              ? shipment?.actual_delivery_date
                              : shipment?.estimated_delivery_date,
                            23
                          )}
                          fontSize={12}
                          fontWeight={400}
                          lineHeight="16px"
                          color="#4B4B4B"
                          marginBottom="0"
                        />
                      </Col>
                    </Row>

                    <Row gutter={[16, 16]} justify="space-between">
                      <Col
                        title={shipment?.to_location?.address}
                        xxl={12}
                        xl={12}
                        lg={12}
                        md={12}
                        sm={24}
                        xs={24}
                      >
                        <CustomParagraph
                          text={"Destination"}
                          fontSize={12}
                          fontWeight={600}
                          lineHeight="16px"
                          color="#000"
                          marginBottom="4px"
                        />

                        <CustomParagraph
                          text={shipment?.to_location?.address}
                          fontSize={12}
                          fontWeight={400}
                          lineHeight="20px"
                          color="#4B4B4B"
                          marginBottom="0"
                        />
                        {/* <CustomParagraph text={shipment?.shipment_details?.destination?.address} fontSize={14} fontWeight={400} lineHeight="20px" color="#4B4B4B" marginBottom="0" /> */}
                      </Col>
                      <Col
                        title={shipment?.scheduled_delivery_date}
                        xxl={12}
                        xl={12}
                        lg={12}
                        md={12}
                        sm={24}
                        xs={24}
                      >
                        <CustomParagraph
                          text={"Scheduled delivery"}
                          fontSize={12}
                          fontWeight={600}
                          lineHeight="16px"
                          color="#000"
                          marginBottom="4px"
                        />

                        <CustomParagraph
                          text={truncateText(
                            shipment?.scheduled_delivery_date,
                            23
                          )}
                          fontSize={12}
                          fontWeight={400}
                          lineHeight="16px"
                          color="#4B4B4B"
                          marginBottom="0"
                        />
                      </Col>
                    </Row>

                      {!isSharePage && (
                    <Row gutter={[16, 16]} justify="space-between">
                        <Col
                          title={shipment?.courier?.title}
                          xxl={12}
                          xl={12}
                          lg={12}
                          md={12}
                          sm={24}
                          xs={24}
                        >
                          <CustomParagraph
                            text={"Transport provider"}
                            fontSize={12}
                            fontWeight={600}
                            lineHeight="16px"
                            color="#000"
                            marginBottom="4px"
                          />

                          <CustomParagraph
                            text={truncateText(shipment?.courier?.title, 23)}
                            fontSize={12}
                            fontWeight={400}
                            lineHeight="16px"
                            color="#4B4B4B"
                            marginBottom="0"
                          />
                        </Col>

                        <Col
                          title={shipment?.courier_tracking_id}
                          xxl={12}
                          xl={12}
                          lg={12}
                          md={12}
                          sm={24}
                          xs={24}
                        >
                          <CustomParagraph
                            text={`${
                              shipment?.courier?.title || ""
                            } tracking ID`}
                            fontSize={12}
                            fontWeight={500}
                            lineHeight="16px"
                            color="#000"
                            marginBottom="4px"
                          />

                          <CustomParagraph
                            text={truncateText(
                              shipment?.courier_tracking_id,
                              23
                            )}
                            fontSize={12}
                            fontWeight={400}
                            lineHeight="16px"
                            color="#4B4B4B"
                            marginBottom="0"
                          />
                        </Col>
                    </Row>
                      )}

{/* for shared page only  START */}
{isSharePage && 
  <Flex gap={8} style={{ flexWrap: "wrap", margin:'14px 0' }}>
              {/* temprature tag  */}
              <Tooltip
                placement="top"
                title={
                  <p
                    className="fw-semibold"
                    dangerouslySetInnerHTML={{
                      __html: `<span>Temperature sensor reading  </span> <br/> ${
                        shipment?.monitor_info?.timestamp || ""
                      } `,
                    }}
                  />
                }
                arrow={true}
              >
                <Tag
                  icon={
                  <TempratureRangeIcon style={{ fill: "#ffcc00", width: 14, height: 14 }} />
                  }
                  style={{
                    margin: "0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gridGap: "3px",
                    cursor: "pointer",
                    height: "20px",
                    padding: "0 4px",
                    minWidth: "20px",
                    fontWeight: "600",
                    backgroundColor: "#EAF6ED",
                    color: "#0E8345",
                    border: "none",
                    ...getTagStyles(
                      shipment?.product?.temperature_min,
                      shipment?.product?.temperature_max,
                      shipment?.monitor_info?.temperature
                    ),
                  }}
                  onClick={handleTempratureModal}
                >
                  {/* {shipment?.monitor_info?.temperature
                    ? parseInt(shipment?.monitor_info?.temperature) || '--'
                    : '--'} */}
                    {shipment?.monitor_info?.temperature != null && !isNaN(parseInt(shipment.monitor_info.temperature))
  ? parseInt(shipment.monitor_info.temperature)
  : '--'}
                  °C
                </Tag>
              </Tooltip>
              {/* Battery tag  */}
              <Tooltip
                placement="top"
                title={
                  <p
                    className="fw-semibold"
                    dangerouslySetInnerHTML={{
                      __html: `<span>Sensor battery life</span>  <br/> ${
                        shipment?.monitor_info?.timestamp || ""
                      } `,
                    }}
                  />
                } arrow={true}>
                <Tag
                  icon={<BatteryIcon style={{ fill: "#ffcc00", width: 14, height: 14 }} />}
                  style={{
                    margin: "0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gridGap: "3px",
                    cursor: "pointer",
                    height: "20px",
                    fontWeight: "600",
                    padding: "0 4px",
                    minWidth: "20px",
                    backgroundColor: "#EAF6ED",
                    border: "none",
                    color: "#0E8345",
                    ...getBatteryTagStyles(shipment?.monitor_info?.battery),
                  }}
                  onClick={handleBatteryModal}
                >
                   {shipment?.monitor_info?.battery != null && !isNaN(parseInt(shipment.monitor_info.battery))
                    ? parseInt(shipment.monitor_info.battery)
                    : '--'}%
                </Tag>
              </Tooltip>
              {/* light tag  */}
              {shipment?.product?.light && (
                <Tooltip
                  placement="top"
                  title={
                    <p
                      className="fw-semibold"
                      dangerouslySetInnerHTML={{
                        __html: `<span>Light sensor reading</span> <br/> ${
                          shipment?.monitor_info?.timestamp || ""
                        } `,
                      }}
                    />
                  }
                  arrow={true}
                >
                  <Tag
                    icon={<LightIcon style={{ fill: "#ffcc00", width: 14, height: 14 }} />}
                    style={{
                      margin: "0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gridGap: "3px",
                      cursor: "pointer",
                      height: "20px",
                      fontWeight: "600",
                      padding: "0 4px",
                      minWidth: "20px",
                      backgroundColor: "#EAF6ED",
                      border: "none",
                      color: "#0E8345",
                      ...getTagStyles(
                        '',
                        shipment?.product?.light,
                        shipment?.monitor_info?.light
                      ),
                    }}
                    onClick={handleLightModal}
                  >
                   {shipment?.monitor_info?.light != null && !isNaN(parseInt(shipment.monitor_info.light))
  ? parseInt(shipment.monitor_info.light)
  : '--'}lx
                  </Tag>
                </Tooltip>
              )}
              {/* humidity tag  */}
              {shipment?.product?.humidity_max &&
              shipment?.product?.humidity_min ? (
                <Tooltip
                  placement="top"
                  title={
                    <p
                      className="fw-semibold"
                      dangerouslySetInnerHTML={{
                        __html: `<span>Humidity sensor reading</span> <br/> ${
                          shipment?.monitor_info?.timestamp || ""
                        } `,
                      }}
                    />
                  }
                  arrow={true}
                >
                  <Tag
                    icon={<HumidityIcon style={{ fill: "#ffcc00", width: 14, height: 14 }} />}
                    style={{
                      margin: "0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gridGap: "3px",
                      cursor: "pointer",
                      height: "20px",
                      padding: "0 4px",
                      minWidth: "20px",
                      fontWeight: "600",
                      backgroundColor: "#EAF6ED",
                      border: "none",
                      color: "#0E8345",
                      ...getTagStyles(
                        shipment?.product?.humidity_min,
                        shipment?.product?.humidity_max,
                        shipment?.monitor_info?.humidity
                      ),
                    }}
                    onClick={handleHumidityModal}
                  >
                   {shipment?.monitor_info?.humidity != null && !isNaN(parseInt(shipment.monitor_info.humidity))
  ? parseInt(shipment.monitor_info.humidity)
  : '--'}%
                  </Tag>
                </Tooltip>
              ) : null}
              {/* Tilt tag  */}
              {shipment?.product?.tilt && (
                <Tooltip
                  placement="top"
                  title={
                    <p
                      className="fw-semibold"
                      dangerouslySetInnerHTML={{
                        __html: `<span>Tilt sensor reading</span> <br/> ${
                          shipment?.monitor_info?.timestamp || ""
                        } `,
                      }}
                    />
                  }
                  arrow={true}
                >
                  <Tag
                  onClick={handleTiltModal}
                    icon={<TiltIcon style={{ fill: "#ffcc00", width: 14, height: 14 }} />}
                    style={{
                      margin: "0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gridGap: "3px",
                      cursor: "pointer",
                      height: "20px",
                      fontWeight: "600",
                      padding: "0 4px",
                      minWidth: "20px",
                      backgroundColor: "#EAF6ED",
                      border: "none",
                      color: "#0E8345",
                      ...getTagStyles(
                        '',
                        shipment?.product?.tilt,
                        shipment?.monitor_info?.tilt
                      ),
                    }}>
                     {shipment?.monitor_info?.tilt != null && !isNaN(parseInt(shipment.monitor_info.tilt))
  ? parseInt(shipment.monitor_info.tilt)
  : '--'}°
                  </Tag>
                </Tooltip>
              )}
              {/* pressure tag  */}
              {shipment?.product?.pressure_max &&
              shipment?.product?.pressure_min ? (
                <Tooltip
                  placement="top"
                  title={
                    <p
                      className="fw-semibold"
                      dangerouslySetInnerHTML={{
                        __html: `<span>Pressure sensor reading</span> <br/> ${
                          shipment?.monitor_info?.timestamp || ""
                        } `,
                      }}
                    />
                  }
                  arrow={true}
                >
                  <Tag
                  onClick={handlePressureModal}
                    icon={<PressureIcon style={{ fill: "#ffcc00", width: 14, height: 14 }} />}
                    style={{
                      margin: "0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gridGap: "3px",
                      cursor: "pointer",
                      height: "20px",
                      fontWeight: "600",
                      padding: "0 4px",
                      minWidth: "20px",
                      backgroundColor: "#EAF6ED",
                      border: "none",
                      color: "#0E8345",
                      ...getTagStyles(
                        shipment?.product?.pressure_min,
                        shipment?.product?.pressure_max,
                        shipment?.monitor_info?.pressure
                      ),
                    }}>
                           {shipment?.monitor_info?.pressure != null && !isNaN(parseInt(shipment.monitor_info.pressure))
  ? parseInt(shipment.monitor_info.pressure)
  : '--'}  {shipment?.product?.pressure_unit}
                  </Tag>
                </Tooltip>
              ) : null}
              {/* vibility window tag  */}
              <Tooltip
                placement="top"
                title={
                  <p
                    className="fw-semibold"
                    dangerouslySetInnerHTML={{
                      __html: "<span>Viable transit time remaining</span>",
                    }}
                  />
                }
                arrow={true}
              >
                <Tag
                  icon={ <VibilityWindowIcon style={{ fill: "#ffcc00", width: 14, height: 14 }} />}
                  style={{
                    margin: "0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gridGap: "3px",
                    cursor: "pointer",
                    height: "20px",
                    fontWeight: "600",
                    padding: "0 4px",
                    minWidth: "20px",
                    backgroundColor: "#EAF6ED",
                    border: "none",
                    color: "#0E8345",
                    width: "fit-content",
                    ...getVibilityWindowStyles(
                      shipment?.schedule_viability_window, shipment?.status, shipment?.scheduled_delivery_date
                    ),
                  }}
                >
                  {changeToTimeString(shipment?.schedule_viability_window)|| '--hr --min'}
                </Tag>
              </Tooltip>
            </Flex>
}
{/* for shared page only END */}


                    <Divider style={{ margin: "0" }} />
                    {!isSharePage && (
                      <>
                        <Row gutter={[16, 16]} justify="space-between">
                          <Col
                            title={shipment?.product?.name}
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={24}
                            xs={24}
                          >
                            <CustomParagraph
                              text={"Product"}
                              fontSize={12}
                              fontWeight={500}
                              lineHeight="16px"
                              color="#000"
                              marginBottom="4px"
                            />

                            <CustomParagraph
                              text={truncateText(shipment?.product?.name, 23)}
                              fontSize={12}
                              fontWeight={400}
                              lineHeight="16px"
                              color="#4B4B4B"
                              marginBottom="0"
                            />
                          </Col>

                          <Col
                            title={shipment?.product?.quantity}
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={24}
                            xs={24}
                          >
                            <CustomParagraph
                              text={"Product quantity"}
                              fontSize={12}
                              fontWeight={500}
                              lineHeight="16px"
                              color="#000"
                              marginBottom="4px"
                            />

                            <CustomParagraph
                              text={truncateText(
                                shipment?.product?.quantity,
                                23
                              )}
                              fontSize={12}
                              fontWeight={400}
                              lineHeight="16px"
                              color="#4B4B4B"
                              marginBottom="0"
                            />
                          </Col>
                        </Row>

                        <Row gutter={[16, 16]} justify="space-between">
                          <Col
                            title={shipment?.product?.project_id}
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={24}
                            xs={24}
                          >
                            <CustomParagraph
                              text={"Project ID"}
                              fontSize={12}
                              fontWeight={500}
                              lineHeight="16px"
                              color="#000"
                              marginBottom="4px"
                            />

                            <CustomParagraph
                              text={truncateText(
                                shipment?.product?.project_id,
                                23
                              )}
                              fontSize={12}
                              fontWeight={400}
                              lineHeight="16px"
                              color="#4B4B4B"
                              marginBottom="0"
                            />
                          </Col>

                          <Col
                            title={shipment?.product?.temperature_range}
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={24}
                            xs={24}
                          >
                            <CustomParagraph
                              text={"Temperature range"}
                              fontSize={12}
                              fontWeight={500}
                              lineHeight="16px"
                              color="#000"
                              marginBottom="4px"
                            />

                            <CustomParagraph
                              text={truncateText(
                                shipment?.product?.temperature_range,
                                23
                              )}
                              fontSize={12}
                              fontWeight={400}
                              lineHeight="16px"
                              color="#4B4B4B"
                              marginBottom="0"
                            />
                          </Col>
                        </Row>

                        <Row gutter={[16, 16]} justify="space-between">
                          <Col
                            title={shipment?.sensor?.type}
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={24}
                            xs={24}
                          >
                            <CustomParagraph
                              text={"Sensor"}
                              fontSize={12}
                              fontWeight={500}
                              lineHeight="16px"
                              color="#000"
                              marginBottom="4px"
                            />

                            <CustomParagraph
                              text={truncateText(shipment?.sensor?.type, 23)}
                              fontSize={12}
                              fontWeight={400}
                              lineHeight="16px"
                              color="#4B4B4B"
                              marginBottom="0"
                            />
                          </Col>

                          <Col
                            title={shipment?.sensor?.id}
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={24}
                            xs={24}
                          >
                            <CustomParagraph
                              text={"Sensor ID"}
                              fontSize={12}
                              fontWeight={500}
                              lineHeight="16px"
                              color="#000"
                              marginBottom="4px"
                            />

                            <CustomParagraph
                              text={truncateText(shipment?.sensor?.id, 23)}
                              fontSize={12}
                              fontWeight={400}
                              lineHeight="16px"
                              color="#4B4B4B"
                              marginBottom="0"
                            />
                          </Col>
                        </Row>
                      </>
                    )}

                    {isSharePage && productDetails && (
                      <>
                        <Flex justify="space-between" align="center" gap={16}>
                          <CustomTitle
                            text={"Product details"}
                            fontSize={14}
                            fontWeight={600}
                            lineHeight="28px"
                            color="#000"
                            marginBottom="0"
                          />
                        </Flex>

                        <Row gutter={[16, 16]} justify="space-between">
                          <Col
                            title={shipment?.product?.name}
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={24}
                            xs={24}
                          >
                            <CustomParagraph
                              text={"Product"}
                              fontSize={12}
                              fontWeight={600}
                              lineHeight="16px"
                              color="#000"
                              marginBottom="4px"
                            />

                            <CustomParagraph
                              text={truncateText(
                                capitalize(shipment?.product?.name),
                                23
                              )}
                              fontSize={12}
                              fontWeight={400}
                              lineHeight="16px"
                              color="#4B4B4B"
                              marginBottom="0"
                            />
                          </Col>

                          <Col
                            title={shipment?.product?.quantity}
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={24}
                            xs={24}
                          >
                            <CustomParagraph
                              text={"Product quantity"}
                              fontSize={12}
                              fontWeight={600}
                              lineHeight="16px"
                              color="#000"
                              marginBottom="4px"
                            />

                            <CustomParagraph
                              text={truncateText(
                                shipment?.product?.quantity,
                                23
                              )}
                              fontSize={12}
                              fontWeight={400}
                              lineHeight="16px"
                              color="#4B4B4B"
                              marginBottom="0"
                            />
                          </Col>
                        </Row>

                        <Row gutter={[16, 16]} justify="space-between">
                          <Col
                            title={shipment?.product?.product_type}
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={24}
                            xs={24}
                          >
                            <CustomParagraph
                              text={"Product type"}
                              fontSize={12}
                              fontWeight={600}
                              lineHeight="16px"
                              color="#000"
                              marginBottom="4px"
                            />

                            <CustomParagraph
                              text={truncateText(
                                shipment?.product?.product_type,
                                23
                              )}
                              fontSize={12}
                              fontWeight={400}
                              lineHeight="16px"
                              color="#4B4B4B"
                              marginBottom="0"
                            />
                          </Col>
                          <Col
                            title={shipment?.product?.project_id}
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={24}
                            xs={24}
                          >
                            <CustomParagraph
                              text={"Project ID"}
                              fontSize={12}
                              fontWeight={600}
                              lineHeight="16px"
                              color="#000"
                              marginBottom="4px"
                            />

                            <CustomParagraph
                              text={truncateText(
                                shipment?.product?.project_id,
                                23
                              )}
                              fontSize={12}
                              fontWeight={400}
                              lineHeight="16px"
                              color="#4B4B4B"
                              marginBottom="0"
                            />
                          </Col>
                        </Row>

                        <Row gutter={[16, 16]} justify="space-between">
                          <Col
                            title={shipment?.product?.temperature_range}
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={24}
                            xs={24}
                          >
                            <CustomParagraph
                              text={"Temperature range"}
                              fontSize={12}
                              fontWeight={600}
                              lineHeight="16px"
                              color="#000"
                              marginBottom="4px"
                            />

                            <CustomParagraph
                              text={truncateText(
                                shipment?.product?.temperature_range,
                                23
                              )}
                              fontSize={12}
                              fontWeight={400}
                              lineHeight="16px"
                              color="#4B4B4B"
                              marginBottom="0"
                            />
                          </Col>

                          <Col
                            title={shipment?.product?.viability_window}
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={24}
                            xs={24}
                          >
                            <CustomParagraph
                              text={"Transit viability window"}
                              fontSize={12}
                              fontWeight={600}
                              lineHeight="16px"
                              color="#000"
                              marginBottom="4px"
                            />

                            <CustomParagraph
                              text={
                                truncateText(
                                  shipment?.product?.viability_window,
                                  23
                                ) + " hrs"
                              }
                              fontSize={12}
                              fontWeight={400}
                              lineHeight="16px"
                              color="#4B4B4B"
                              marginBottom="0"
                            />
                          </Col>
                        </Row>

                        <Row gutter={[16, 16]} justify="space-between">
                          <Col
                            title={shipment?.sensor?.type}
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={24}
                            xs={24}
                          >
                            <CustomParagraph
                              text={"Sensor"}
                              fontSize={12}
                              fontWeight={600}
                              lineHeight="16px"
                              color="#000"
                              marginBottom="4px"
                            />

                            <CustomParagraph
                              text={
                                shipment?.sensor?.type
                                  ? truncateText(shipment?.sensor?.type, 23)
                                  : "N/A"
                              }
                              fontSize={12}
                              fontWeight={400}
                              lineHeight="16px"
                              color="#4B4B4B"
                              marginBottom="0"
                            />
                          </Col>

                          <Col
                            title={shipment?.sensor?.id}
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={24}
                            xs={24}
                          >
                            <CustomParagraph
                              text={"Sensor ID"}
                              fontSize={12}
                              fontWeight={600}
                              lineHeight="16px"
                              color="#000"
                              marginBottom="4px"
                            />

                            <CustomParagraph
                              text={truncateText(shipment?.sensor?.id, 23)}
                              fontSize={12}
                              fontWeight={400}
                              lineHeight="16px"
                              color="#4B4B4B"
                              marginBottom="0"
                            />
                          </Col>
                        </Row>
                      </>
                    )}
                    {isSharePage && (
                      <>
                        <Flex justify="space-between" align="center" gap={16}>
                          <CustomTitle
                            text={"Transport provider"}
                            fontSize={14}
                            fontWeight={600}
                            lineHeight="28px"
                            color="#000"
                            marginBottom="0"
                          />
                        </Flex>

                        <Row gutter={[16, 16]} justify="space-between">
                          <Col
                            title={shipment?.courier?.title}
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={24}
                            xs={24}
                          >
                            <CustomParagraph
                              text={"Transport provider"}
                              fontSize={12}
                              fontWeight={600}
                              lineHeight="16px"
                              color="#000"
                              marginBottom="4px"
                            />

                            <CustomParagraph
                              text={truncateText(shipment?.courier?.title, 23)}
                              fontSize={12}
                              fontWeight={400}
                              lineHeight="16px"
                              color="#4B4B4B"
                              marginBottom="0"
                            />
                          </Col>

                          <Col
                            title={shipment?.contact_phone}
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={24}
                            xs={24}
                          >
                            <CustomParagraph
                              text={"Contact phone"}
                              fontSize={12}
                              fontWeight={600}
                              lineHeight="16px"
                              color="#000"
                              marginBottom="4px"
                            />

                            <CustomParagraph
                              text={truncateText(shipment?.contact_phone, 23)}
                              fontSize={12}
                              fontWeight={400}
                              lineHeight="16px"
                              color="#4B4B4B"
                              marginBottom="0"
                            />
                          </Col>
                        </Row>

                        <Row gutter={[16, 16]} justify="space-between">
                          <Col
                            title={shipment?.courier_tracking_id}
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={24}
                            xs={24}
                          >
                            <CustomParagraph
                              text={"Tracking ID"}
                              fontSize={12}
                              fontWeight={600}
                              lineHeight="16px"
                              color="#000"
                              marginBottom="4px"
                            />

                            {shipment?.courier?.tracking_link ? (
                              <>
                              <a
                                href={shipment.courier.tracking_link}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  // textDecoration: "underline",
                                  fontSize: 12,
                                  fontWeight: 400,
                                  lineHeight: "16px",
                                  color: "#4B4B4B",

                                  cursor: "pointer",
                                  display: "inline-block",
                                }}
                              >
                                {truncateText(
                                  shipment?.courier_tracking_id,
                                  18
                                )}
                                <img src={arrowLink} alt='arrow' width={15} style={{marginLeft:"3px"}}/>
                              </a>
                              
                              </>
                            ) : (
                              <span
                                style={{
                                  fontSize: 12,
                                  fontWeight: 400,
                                  lineHeight: "16px",
                                  color: "#4B4B4B",
                                  display: "inline-block",
                                }}
                              >
                                {truncateText(
                                  shipment?.courier_tracking_id,
                                  23
                                )}
                              </span>
                            )}
                          </Col>

                          <Col
                            title={shipment?.transport_provider_eta}
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={24}
                            xs={24}
                          >
                            <CustomParagraph
                              text={"Transport provider ETA"}
                              fontSize={12}
                              fontWeight={600}
                              lineHeight="16px"
                              color="#000"
                              marginBottom="4px"
                            />

                            <CustomParagraph
                              text={truncateText(
                                shipment?.transport_provider_eta,
                                23
                              )}
                              fontSize={12}
                              fontWeight={400}
                              lineHeight="16px"
                              color="#4B4B4B"
                              marginBottom="0"
                            />
                          </Col>
                        </Row>
                      </>
                    )}

                    {isSharePage && (
                      <>
                        <Flex justify="space-between" align="center" gap={16}>
                          <CustomTitle
                            text={"Live chain of custody"}
                            fontSize={14}
                            fontWeight={600}
                            lineHeight="28px"
                            color="#000"
                            marginBottom="0px"
                          />
                        </Flex>
                        <div className="custom-timeline">
                          {/* <Timeline mode="left">
                          {shipment?.chain_of_custody?.map((custody, index) => (
                            ((custody?.type !== 1 || (custody?.type == 1 && showAlerts)) && (
                            <Timeline.Item
                              key={index}
                              dot={
                                (custody?.type == 1 && showAlerts) ? (
                                  <img
                                    src={CommentIcon}
                                    style={{ width: "20px", height: "20px" }}
                                  />
                                ) : (custody?.type == 1 && !showAlerts) ? " " : custody?.type == 3 &&
                                  custody?.is_critical === 0 ? (
                                  <img
                                    src={AtRisk}
                                    style={{ width: "20px", height: "20px" }}
                                  />
                                ) : custody?.is_critical === 1 &&
                                  custody?.type == 3 ? (
                                  <Flex
                                    align="center"
                                    justify="center"
                                    style={{
                                      backgroundColor: "#DE1135",
                                      borderRadius: "50%",
                                      width: "26px",
                                      height: "26px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: "13px",
                                        color: "white",
                                      }}
                                    >
                                      <ExclamationCircleFilled />
                                    </span>
                                  </Flex>
                                ) : (
                                  <div
                                    style={{
                                      backgroundColor: "#000",
                                      width: 10,
                                      height: 10,
                                      borderRadius: "50%",
                                    }}
                                  />
                                )
                              }
                            >
                              (custody.type==1 && showAlerts) ? 
                              <CustomParagraph
                                text={String(custody?.action || "")}
                                fontSize={12}
                                fontWeight={600}
                                lineHeight="16px"
                                color="#000"
                                marginBottom="10px"
                              />
                              <CustomParagraph
                                text={String(custody?.comment || "")}
                                fontSize={12}
                                fontWeight={400}
                                lineHeight="16px"
                                color="#4B4B4B"
                                marginBottom="4px"
                              />
                              <CustomParagraph
                                text={String(custody?.location || "")}
                                fontSize={12}
                                fontWeight={400}
                                lineHeight="16px"
                                color="#4B4B4B"
                                marginBottom="4px"
                              />
                              <CustomParagraph
                                text={String(custody?.timestamp || "")}
                                fontSize={12}
                                fontWeight={400}
                                lineHeight="16px"
                                color="#4B4B4B"
                                marginBottom="0"
                              />
                              : 

                              <CustomParagraph
                                text={String(custody?.action || "")}
                                fontSize={12}
                                fontWeight={600}
                                lineHeight="16px"
                                color="#000"
                                marginBottom="10px"
                              />
                              <CustomParagraph
                                text={String(custody?.comment || "")}
                                fontSize={12}
                                fontWeight={400}
                                lineHeight="16px"
                                color="#4B4B4B"
                                marginBottom="4px"
                              />
                              <CustomParagraph
                                text={String(custody?.location || "")}
                                fontSize={12}
                                fontWeight={400}
                                lineHeight="16px"
                                color="#4B4B4B"
                                marginBottom="4px"
                              />
                              <CustomParagraph
                                text={String(custody?.timestamp || "")}
                                fontSize={12}
                                fontWeight={400}
                                lineHeight="16px"
                                color="#4B4B4B"
                                marginBottom="0"
                              />
                              {custody?.alert_completion && (
                                <Row
                                  style={{
                                    marginTop: "12px",
                                    marginBottom: "12px",
                                  }}
                                >
                                  <Col
                                    span={4}
                                    style={{
                                      display: "flex",
                                      justifyContent: "end",
                                      alignItems: "center",
                                      marginRight: "20px",
                                    }}
                                  >
                                    {custody?.alert_completion?.status ==
                                    "Resolved" ? (
                                      <Flex
                                        align="center"
                                        justify="center"
                                        style={{
                                          backgroundColor: "#0E8345",
                                          borderRadius: "50%",
                                          width: "20px",
                                          height: "20px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: "15px",
                                            color: "white",
                                          }}
                                        >
                                          <CheckOutlined />
                                        </span>
                                      </Flex>
                                    ) : (
                                      <Flex
                                        align="center"
                                        justify="center"
                                        style={{
                                          backgroundColor: "#000",
                                          borderRadius: "50%",
                                          width: "20px",
                                          height: "20px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: "15px",
                                            color: "white",
                                          }}
                                        >
                                          <MinusOutlined />
                                        </span>
                                      </Flex>
                                    )}
                                  </Col>
                                  <Col>
                                    <CustomParagraph
                                      text={
                                        (custody?.alert_completion?.status ==
                                        "Resolved"
                                          ? "Resolved by"
                                          : "Dismissed by") +
                                        " " +
                                        String(
                                          custody?.alert_completion?.name || ""
                                        )
                                      }
                                      fontSize={12}
                                      fontWeight={600}
                                      lineHeight="16px"
                                      color="#000"
                                      marginBottom="0px"
                                    />
                                    <CustomParagraph
                                      text={String(
                                        custody?.alert_completion?.comment || ""
                                      )}
                                      fontSize={12}
                                      fontWeight={400}
                                      lineHeight="16px"
                                      color="#4B4B4B"
                                      marginBottom="4px"
                                    />
                                    <CustomParagraph
                                      text={String(
                                        custody?.alert_completion
                                          ?.completed_at || ""
                                      )}
                                      fontSize={12}
                                      fontWeight={400}
                                      lineHeight="16px"
                                      color="#4B4B4B"
                                      marginBottom="0"
                                    />
                                  </Col>
                                </Row>
                              )}
                            </Timeline.Item>
                            ) 
                          ))}
                        </Timeline> */}
                          <Timeline mode="left">
                            {shipment?.chain_of_custody?.map(
                              (custody, index) =>
                                (custody?.type !== 1 ||
                                  (custody?.type === 1 && showAlerts)) && (
                                  <Timeline.Item
                                    key={index}
                                    dot={
                                      custody?.type === 1 ? (
                                        <img
                                          src={CommentIcon}
                                          style={{
                                            width: "20px",
                                            height: "20px",
                                          }}
                                        />
                                      ) : custody?.type === 3 &&
                                        custody?.is_critical === 0 ? (
                                        <img
                                          src={AtRisk}
                                          style={{
                                            width: "20px",
                                            height: "20px",
                                          }}
                                        />
                                      ) : custody?.type === 3 &&
                                        custody?.is_critical === 1 ? (
                                        <Flex
                                          align="center"
                                          justify="center"
                                          style={{
                                            backgroundColor: "#DE1135",
                                            borderRadius: "50%",
                                            width: "26px",
                                            height: "26px",
                                          }}
                                        >
                                          <span
                                            style={{
                                              fontSize: "13px",
                                              color: "white",
                                            }}
                                          >
                                            <ExclamationCircleFilled />
                                          </span>
                                        </Flex>
                                      ) : (
                                        <div
                                          style={{
                                            backgroundColor: "#000",
                                            width: 10,
                                            height: 10,
                                            borderRadius: "50%",
                                          }}
                                        />
                                      )
                                    }
                                  >
                                    <>
                                      <CustomParagraph
                                        text={String(custody?.action || "")}
                                        fontSize={12}
                                        fontWeight={600}
                                        lineHeight="16px"
                                        color="#000"
                                        marginBottom="10px"
                                      />
                                      <CustomParagraph
                                        text={String(custody?.comment || "")}
                                        fontSize={12}
                                        fontWeight={400}
                                        lineHeight="16px"
                                        color="#4B4B4B"
                                        marginBottom="4px"
                                      />
                                      <CustomParagraph
                                        text={String(custody?.location || "")}
                                        fontSize={12}
                                        fontWeight={400}
                                        lineHeight="16px"
                                        color="#4B4B4B"
                                        marginBottom="4px"
                                      />
                                      <CustomParagraph
                                        text={String(custody?.timestamp || "")}
                                        fontSize={12}
                                        fontWeight={400}
                                        lineHeight="16px"
                                        color="#4B4B4B"
                                        marginBottom="0"
                                      />
                                    </>

                                    {custody?.alert_completion && (
                                      <Row
                                        style={{
                                          marginTop: "12px",
                                          marginBottom: "12px",
                                        }}
                                      >
                                        <Col
                                          span={4}
                                          style={{
                                            display: "flex",
                                            justifyContent: "end",
                                            alignItems: "center",
                                            marginRight: "20px",
                                          }}
                                        >
                                          {custody?.alert_completion?.status ===
                                          "Resolved" ? (
                                            <Flex
                                              align="center"
                                              justify="center"
                                              style={{
                                                backgroundColor: "#0E8345",
                                                borderRadius: "50%",
                                                width: "20px",
                                                height: "20px",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  fontSize: "15px",
                                                  color: "white",
                                                }}
                                              >
                                                <CheckOutlined />
                                              </span>
                                            </Flex>
                                          ) : (
                                            <Flex
                                              align="center"
                                              justify="center"
                                              style={{
                                                backgroundColor: "#000",
                                                borderRadius: "50%",
                                                width: "20px",
                                                height: "20px",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  fontSize: "15px",
                                                  color: "white",
                                                }}
                                              >
                                                <MinusOutlined />
                                              </span>
                                            </Flex>
                                          )}
                                        </Col>
                                        <Col>
                                          <CustomParagraph
                                            text={
                                              (custody?.alert_completion
                                                ?.status === "Resolved"
                                                ? "Resolved by"
                                                : "Dismissed by") +
                                              " " +
                                              String(
                                                custody?.alert_completion
                                                  ?.name || ""
                                              )
                                            }
                                            fontSize={12}
                                            fontWeight={600}
                                            lineHeight="16px"
                                            color="#000"
                                            marginBottom="0px"
                                          />
                                          <CustomParagraph
                                            text={String(
                                              custody?.alert_completion
                                                ?.comment || ""
                                            )}
                                            fontSize={12}
                                            fontWeight={400}
                                            lineHeight="16px"
                                            color="#4B4B4B"
                                            marginBottom="4px"
                                          />
                                          <CustomParagraph
                                            text={String(
                                              custody?.alert_completion
                                                ?.completed_at || ""
                                            )}
                                            fontSize={12}
                                            fontWeight={400}
                                            lineHeight="16px"
                                            color="#4B4B4B"
                                            marginBottom="0"
                                          />
                                        </Col>
                                      </Row>
                                    )}
                                  </Timeline.Item>
                                )
                            )}
                          </Timeline>
                        </div>
                      </>
                    )}

                       {/* <Flex justify="space-between" align="center" gap={16}>
                      <Flex gap={8}>
                        <Tag
                          icon={<img src={temp} alt="" />}
                          style={{
                            margin: "0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            gridGap: "3px",
                            cursor: "pointer",
                            height: "20px",
                            padding: "0 4px",
                            minWidth: "20px",
                            backgroundColor: "#EAF6ED",
                            border: "none",
                            color: "#0E8345",
                          }}
                          onClick={handleTempratureModal}
                        >
                          {pointState?.temperature
                            ? parseInt(pointState?.temperature) || 0
                            : 0}
                          °C
                        </Tag>
                        <Tag
                          icon={<img src={battery} alt="" />}
                          style={{
                            margin: "0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            gridGap: "3px",
                            cursor: "pointer",
                            height: "20px",
                            padding: "0 4px",
                            minWidth: "20px",
                            backgroundColor: "#EAF6ED",
                            border: "none",
                            color: "#0E8345",
                          }}
                          onClick={handleBatteryModal}
                        >
                          {pointState?.battery
                            ? parseInt(pointState?.battery) || 0
                            : 0}
                          %
                        </Tag>

                        <Tag
                          style={{
                            margin: "0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            gridGap: "3px",
                            cursor: "pointer",
                            height: "20px",
                            padding: "0 4px",
                            minWidth: "20px",
                            backgroundColor: "#EAF6ED",
                            border: "none",
                            color: "#0E8345",
                          }}
                          onClick={handleLightModal}
                          icon={<img src={lightIcon} alt="" />}
                        >
                          {shipment?.monitor_info?.light
                            ? parseInt(shipment?.monitor_info?.light) || 0
                            : 0}
                          lx
                        </Tag>

                        <Tag
                          style={{
                            margin: "0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            gridGap: "3px",
                            cursor: "pointer",
                            height: "20px",
                            padding: "0 4px",
                            minWidth: "20px",
                            backgroundColor: "#EAF6ED",
                            border: "none",
                            color: "#0E8345",
                          }}
                          onClick={handleHumidityModal}
                          icon={<img src={humidityIcon} alt="" />}
                        >
                          {shipment?.monitor_info?.humidity
                            ? parseInt(shipment?.monitor_info?.humidity) || 0
                            : 0}
                          %
                        </Tag>

                        <Tag
                          style={{
                            margin: "0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            gridGap: "3px",
                            cursor: "pointer",
                            height: "20px",
                            padding: "0 4px",
                            minWidth: "20px",
                            backgroundColor: "#EAF6ED",
                            border: "none",
                            color: "#0E8345",
                          }}
                          icon={<img src={time} alt="" />}
                        >
                          {changeToTimeString(
                            shipment?.schedule_viability_window
                          )}
                        </Tag>
                      </Flex>
                    </Flex>     */}


{/* new vitls with colors  */}

{!isSharePage && 
  <Flex gap={8} style={{ flexWrap: "wrap" }}>
              {/* temprature tag  */}
              <Tooltip
                placement="top"
                title={
                  <p
                    className="fw-semibold"
                    dangerouslySetInnerHTML={{
                      __html: `<span>Temperature sensor reading  </span> <br/> ${
                        shipment?.monitor_info?.timestamp || ""
                      } `,
                    }}
                  />
                }
                arrow={true}
              >
                <Tag
                  icon={
                  <TempratureRangeIcon style={{ fill: "#ffcc00", width: 14, height: 14 }} />
                  }
                  style={{
                    margin: "0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gridGap: "3px",
                    cursor: "pointer",
                    height: "20px",
                    padding: "0 4px",
                    minWidth: "20px",
                    fontWeight: "600",
                    backgroundColor: "#EAF6ED",
                    color: "#0E8345",
                    border: "none",
                    ...getTagStyles(
                      shipment?.product?.temperature_min,
                      shipment?.product?.temperature_max,
                      shipment?.monitor_info?.temperature
                    ),
                  }}
                  onClick={handleTempratureModal}
                >
                  {/* {shipment?.monitor_info?.temperature
                    ? parseInt(shipment?.monitor_info?.temperature) || '--'
                    : '--'} */}
                    {shipment?.monitor_info?.temperature != null && !isNaN(parseInt(shipment.monitor_info.temperature))
  ? parseInt(shipment.monitor_info.temperature)
  : '--'}
                  °C
                </Tag>
              </Tooltip>
              {/* Battery tag  */}
              <Tooltip
                placement="top"
                title={
                  <p
                    className="fw-semibold"
                    dangerouslySetInnerHTML={{
                      __html: `<span>Sensor battery life</span>  <br/> ${
                        shipment?.monitor_info?.timestamp || ""
                      } `,
                    }}
                  />
                } arrow={true}>
                <Tag
                  icon={<BatteryIcon style={{ fill: "#ffcc00", width: 14, height: 14 }} />}
                  style={{
                    margin: "0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gridGap: "3px",
                    cursor: "pointer",
                    height: "20px",
                    fontWeight: "600",
                    padding: "0 4px",
                    minWidth: "20px",
                    backgroundColor: "#EAF6ED",
                    border: "none",
                    color: "#0E8345",
                    ...getBatteryTagStyles(shipment?.monitor_info?.battery),
                  }}
                  onClick={handleBatteryModal}
                >
                   {shipment?.monitor_info?.battery != null && !isNaN(parseInt(shipment.monitor_info.battery))
                    ? parseInt(shipment.monitor_info.battery)
                    : '--'}%
                </Tag>
              </Tooltip>
              {/* light tag  */}
              {shipment?.product?.light && (
                <Tooltip
                  placement="top"
                  title={
                    <p
                      className="fw-semibold"
                      dangerouslySetInnerHTML={{
                        __html: `<span>Light sensor reading</span> <br/> ${
                          shipment?.monitor_info?.timestamp || ""
                        } `,
                      }}
                    />
                  }
                  arrow={true}
                >
                  <Tag
                    icon={<LightIcon style={{ fill: "#ffcc00", width: 14, height: 14 }} />}
                    style={{
                      margin: "0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gridGap: "3px",
                      cursor: "pointer",
                      height: "20px",
                      fontWeight: "600",
                      padding: "0 4px",
                      minWidth: "20px",
                      backgroundColor: "#EAF6ED",
                      border: "none",
                      color: "#0E8345",
                      ...getTagStyles(
                        '',
                        shipment?.product?.light,
                        shipment?.monitor_info?.light
                      ),
                    }}
                    onClick={handleLightModal}
                  >
                   {shipment?.monitor_info?.light != null && !isNaN(parseInt(shipment.monitor_info.light))
  ? parseInt(shipment.monitor_info.light)
  : '--'}lx
                  </Tag>
                </Tooltip>
              )}
              {/* humidity tag  */}
              {shipment?.product?.humidity_max &&
              shipment?.product?.humidity_min ? (
                <Tooltip
                  placement="top"
                  title={
                    <p
                      className="fw-semibold"
                      dangerouslySetInnerHTML={{
                        __html: `<span>Humidity sensor reading</span> <br/> ${
                          shipment?.monitor_info?.timestamp || ""
                        } `,
                      }}
                    />
                  }
                  arrow={true}
                >
                  <Tag
                    icon={<HumidityIcon style={{ fill: "#ffcc00", width: 14, height: 14 }} />}
                    style={{
                      margin: "0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gridGap: "3px",
                      cursor: "pointer",
                      height: "20px",
                      padding: "0 4px",
                      minWidth: "20px",
                      fontWeight: "600",
                      backgroundColor: "#EAF6ED",
                      border: "none",
                      color: "#0E8345",
                      ...getTagStyles(
                        shipment?.product?.humidity_min,
                        shipment?.product?.humidity_max,
                        shipment?.monitor_info?.humidity
                      ),
                    }}
                    onClick={handleHumidityModal}
                  >
                   {shipment?.monitor_info?.humidity != null && !isNaN(parseInt(shipment.monitor_info.humidity))
  ? parseInt(shipment.monitor_info.humidity)
  : '--'}%
                  </Tag>
                </Tooltip>
              ) : null}
              {/* Tilt tag  */}
              {shipment?.product?.tilt && (
                <Tooltip
                  placement="top"
                  title={
                    <p
                      className="fw-semibold"
                      dangerouslySetInnerHTML={{
                        __html: `<span>Tilt sensor reading</span> <br/> ${
                          shipment?.monitor_info?.timestamp || ""
                        } `,
                      }}
                    />
                  }
                  arrow={true}
                >
                  <Tag
                  onClick={handleTiltModal}
                    icon={<TiltIcon style={{ fill: "#ffcc00", width: 14, height: 14 }} />}
                    style={{
                      margin: "0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gridGap: "3px",
                      cursor: "pointer",
                      height: "20px",
                      fontWeight: "600",
                      padding: "0 4px",
                      minWidth: "20px",
                      backgroundColor: "#EAF6ED",
                      border: "none",
                      color: "#0E8345",
                      ...getTagStyles(
                        '',
                        shipment?.product?.tilt,
                        shipment?.monitor_info?.tilt
                      ),
                    }}>
                     {shipment?.monitor_info?.tilt != null && !isNaN(parseInt(shipment.monitor_info.tilt))
  ? parseInt(shipment.monitor_info.tilt)
  : '--'}°
                  </Tag>
                </Tooltip>
              )}
              {/* pressure tag  */}
              {shipment?.product?.pressure_max &&
              shipment?.product?.pressure_min ? (
                <Tooltip
                  placement="top"
                  title={
                    <p
                      className="fw-semibold"
                      dangerouslySetInnerHTML={{
                        __html: `<span>Pressure sensor reading</span> <br/> ${
                          shipment?.monitor_info?.timestamp || ""
                        } `,
                      }}
                    />
                  }
                  arrow={true}
                >
                  <Tag
                  onClick={handlePressureModal}
                    icon={<PressureIcon style={{ fill: "#ffcc00", width: 14, height: 14 }} />}
                    style={{
                      margin: "0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gridGap: "3px",
                      cursor: "pointer",
                      height: "20px",
                      fontWeight: "600",
                      padding: "0 4px",
                      minWidth: "20px",
                      backgroundColor: "#EAF6ED",
                      border: "none",
                      color: "#0E8345",
                      ...getTagStyles(
                        shipment?.product?.pressure_min,
                        shipment?.product?.pressure_max,
                        shipment?.monitor_info?.pressure
                      ),
                    }}>
                           {shipment?.monitor_info?.pressure != null && !isNaN(parseInt(shipment.monitor_info.pressure))
  ? parseInt(shipment.monitor_info.pressure)
  : '--'}  {shipment?.product?.pressure_unit}
                  </Tag>
                </Tooltip>
              ) : null}
              {/* vibility window tag  */}
              <Tooltip
                placement="top"
                title={
                  <p
                    className="fw-semibold"
                    dangerouslySetInnerHTML={{
                      __html: "<span>Viable transit time remaining</span>",
                    }}
                  />
                }
                arrow={true}
              >
                <Tag
                  icon={ <VibilityWindowIcon style={{ fill: "#ffcc00", width: 14, height: 14 }} />}
                  style={{
                    margin: "0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gridGap: "3px",
                    cursor: "pointer",
                    height: "20px",
                    fontWeight: "600",
                    padding: "0 4px",
                    minWidth: "20px",
                    backgroundColor: "#EAF6ED",
                    border: "none",
                    color: "#0E8345",
                    width: "fit-content",
                    ...getVibilityWindowStyles(
                      shipment?.schedule_viability_window, shipment?.status, shipment?.scheduled_delivery_date
                    ),
                  }}
                >
                  {changeToTimeString(shipment?.schedule_viability_window)|| '--hr --min'}
                </Tag>
              </Tooltip>
            </Flex>
}



                  </Flex>
                </Flex>
                </div>
      }

              </div>
            </div>
          </div>

          {lightModalOpen &&
            shipment?.shipment_monitor &&
            shipment?.shipment_monitor?.length > 0 && (
              <CustomModalWithoutButton
                modalOpen={lightModalOpen}
                setModalOpen={setLightModalOpen}
                modalTitle="Light"
                modalText=""
                modalSize={615}
              >
                <LightModal
                  min={shipment?.product?.temperature_min}
                  max={shipment?.product?.temperature_min}
                  shipment_monitor={shipment?.shipment_monitor}
                />
              </CustomModalWithoutButton>
            )}

          {humidityModalOpen &&
            shipment?.shipment_monitor &&
            shipment?.shipment_monitor?.length > 0 && (
              <CustomModalWithoutButton
                modalOpen={humidityModalOpen}
                setModalOpen={setHumidityModalOpen}
                modalTitle="Humidity"
                modalText=""
                modalSize={615}
              >
                <HumidityModal
                  min={shipment?.product?.temperature_min}
                  max={shipment?.product?.temperature_min}
                  shipment_monitor={shipment?.shipment_monitor}
                />
              </CustomModalWithoutButton>
            )}
{/* temperatue chart modal  */}
          {tempratureModalOpen &&
            shipment?.shipment_monitor &&
            shipment?.shipment_monitor?.length > 0 && (
              <CustomModalWithoutButton
                modalOpen={tempratureModalOpen}
                setModalOpen={setTempratureModalOpen}
                modalTitle="Temperature"
                modalText=""
                modalSize={615}
              >
                <TemperatureModal
                  min={shipment?.product?.temperature_min}
                  max={shipment?.product?.temperature_min}
                  shipment_monitor={shipment?.shipment_monitor}
                />
              </CustomModalWithoutButton>
            )}
 {/* Tilt Chart modal  */}

          {tiltModalOpen &&
            shipment?.shipment_monitor &&
            shipment?.shipment_monitor?.length > 0 && (
              <CustomModalWithoutButton
                modalOpen={tiltModalOpen}
                setModalOpen={setTiltModalOpen}
                modalTitle="Tilt"
                modalText=""
                modalSize={615}
              >
                <TiltModal
                  shipment_monitor={shipment?.shipment_monitor}
                />
              </CustomModalWithoutButton>
            )}

            {/* pressure chart modal  */}

      {pressureModalOpen &&
        shipment?.shipment_monitor &&
        shipment?.shipment_monitor?.length > 0 && (
          <CustomModalWithoutButton
            modalOpen={pressureModalOpen}
            setModalOpen={setPressureModalOpen}
            modalTitle="Pressure"
            modalText=""
            modalSize={715}
          >
            <PressureChartModal
              pressureUnit={shipment?.product}
              min={shipment?.product?.pressure_min}
              max={shipment?.product?.pressure_max}
              shipment_monitor={shipment?.shipment_monitor}
            />
          </CustomModalWithoutButton>
        )}

{/* Battery Chart modal  */}
          {batteryModalOpen &&
            shipment?.shipment_monitor &&
            shipment?.shipment_monitor?.length > 0 && (
              <CustomModalWithoutButton
                modalOpen={batteryModalOpen}
                setModalOpen={setBatteryModalOpen}
                modalTitle="Sensor battery life"
                modalText=""
                modalSize={615}
              >
                <BatteryModal shipment_monitor={shipment?.shipment_monitor} />
              </CustomModalWithoutButton>
            )}
        </>
      )}
    </>
  );
}

export default MapExternalView;
